import { UserTypeConstants } from "../types/UserTypeConstants";

export const UserActions = {
  login,
  loginSuccess,
  loginFailiure,
  logout,
  register,
  registerSuccess,
  registerFailiure,
  verifyUser,
  changePassword,
  updatePassword,
  validateEmail,
  validateEmailSuccess,
  validateSecretQuestion,
  validateSecretQuestionSuccess,
  validateOTPError,
  validateOTPSuccess,
  validateOTP,
  sendOTPError,
  sendOTPSuccess,
  sendOTP,
};

function login(user) {
  return { type: UserTypeConstants.LOGIN_REQUEST, user };
}

function loginSuccess(user) {
  return { type: UserTypeConstants.LOGIN_SUCCESS, user };
}

function loginFailiure(message) {
  return { type: UserTypeConstants.LOGIN_FAILURE, message };
}

function registerSuccess(data) {
  return { type: UserTypeConstants.REGISTER_SUCCESS, data };
}

function registerFailiure(action) {
  return { type: UserTypeConstants.REGISTER_FAILURE, message: action };
}

function register(user) {
  return { type: UserTypeConstants.REGISTER_REQUEST, user };
}

function verifyUser() {
  return { type: UserTypeConstants.VERIFY_USER };
}
function logout() {
  return { type: UserTypeConstants.LOGOUT };
}

function changePassword(data) {
  return { type: UserTypeConstants.CHANGE_PASSWORD, data };
}
function updatePassword(data) {
  return { type: UserTypeConstants.UPDATE_PASSWORD, data };
}

function validateEmail(email) {
  return { type: UserTypeConstants.VALIDATE_EMAIL, email };
}

function validateEmailSuccess(data) {
  return { type: UserTypeConstants.VALIDATE_EMAIL_SUCCESS, data };
}

function validateSecretQuestion(data) {
  return { type: UserTypeConstants.VALIDATE_SECRET_QUESTION_REQUEST, data };
}

function validateSecretQuestionSuccess(data) {
  return { type: UserTypeConstants.VALIDATE_SECRET_QUESTION_SUCCESS, data };
}

function sendOTP(data) {
  return { type: UserTypeConstants.SEND_OTP_REQUEST, data };
}
function sendOTPSuccess(data) {
  return { type: UserTypeConstants.SEND_OTP_SUCCESS, data };
}
function sendOTPError(data) {
  return { type: UserTypeConstants.SEND_OTP_FAILIURE, data };
}

function validateOTP(data) {
  return { type: UserTypeConstants.VALIDATE_OTP_REQUEST, data };
}
function validateOTPSuccess() {
  return { type: UserTypeConstants.VALIDATE_OTP_SUCCESS };
}
function validateOTPError() {
  return { type: UserTypeConstants.VALIDATE_OTP_FAILIURE };
}
